export const SIGNUP_SELECT_IDENTITY = 'SIGNUP_SELECT_IDENTITY';
export const SIGNUP_QUALIFICATION = 'SIGNUP_QUALIFICATION';
export const SIGNIN_SELECT_IDENTITY = 'SIGNIN_SELECT_IDENTITY';
export const SIGNIN_INCOMPLETE_QUALIFICATION = 'SIGNIN_INCOMPLETE_QUALIFICATION';
